<template>
  <div class="projects">
    <div class="project-list panel list-panel">
      <el-container>
        <el-header class="clearfix">
          <h2 class="card-title">Projects</h2>
          <project-filters />
          <div class="pull-right">
            <el-button class="header-btn pull-right"
                       type="primary"
                       icon="el-icon-circle-plus"
                       @click="createProject">Create New Project</el-button>
            <div class="search-bar pull-right">
              <el-input placeholder="Search..." v-model="searchTerm" />
            </div>
          </div>
        </el-header>
        <project-list :projects="projects"
                      :search-term="searchTerm"/>
      </el-container>
    </div>
    <project-crud v-if="showProjectCrud"
                  @close="projectCrudClose" />
  </div>
</template>

<script>
  export default {
    name: 'projects',
    data () {
      return {
        showProjectCrud: false,
        searchTerm: ''
      }
    },
    methods: {
      createProject () {
        this.showProjectCrud = true
      },
      projectCrudClose (project) {
        // Handle the Project Crud Dialog closing
        this.showProjectCrud = false

        if (project) {
          this.$router.push({name: 'project', params: { project_id: project.id }})
        }
      }
    },
    computed: {
      projects () {
        return Object.keys(this.$store.state.projects.objects).map((k) => this.$store.state.projects.objects[k])
      }
    },
    mounted () {
      this.$store.dispatch('setPageTitle', 'Projects')
      setTimeout(() => {
        this.$store.dispatch('getProjects')
      }, 500)
    }
  }
</script>
